var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "oa-dialog" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            top: "10%",
            visible: _vm.show,
            width: _vm.fromData.width || "500px",
            "show-close": false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.show = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "header", attrs: { slot: "title" }, slot: "title" },
            [
              _c("span", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.fromData.title)),
              ]),
              _vm._v(" "),
              _c("span", {
                staticClass: "el-icon-close",
                on: { click: _vm.handleClose },
              }),
            ]
          ),
          _vm._v(" "),
          _vm.fromData.type == "slot"
            ? _c("div", [_vm._t("default")], 2)
            : _c(
                "div",
                { staticClass: "invite" },
                [
                  _c("oaForm", {
                    ref: "oaForm",
                    attrs: {
                      fromData: _vm.fromData,
                      formConfig: _vm.formConfig,
                      formDataInit: _vm.formDataInit,
                      formRules: _vm.formRules,
                    },
                    on: { submit: _vm.submitOk },
                  }),
                ],
                1
              ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.handleClose } },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.submit },
                },
                [_vm._v(_vm._s(_vm.fromData.btnText))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }